export const DEFAULT_PLAYERS = [
  { id: 1, x: 400, y: 200, rotation: 0, img: "/icons/BlueArrowIcon.png" },
  { id: 2, x: 400, y: 400, rotation: 0, img: "/icons/BlueArrowIcon.png" },
  { id: 3, x: 400, y: 600, rotation: 0, img: "/icons/BlueArrowIcon.png" },
  { id: 4, x: 400, y: 800, rotation: 0, img: "/icons/BlueArrowIcon.png" },
  { id: 5, x: 1520, y: 200, rotation: 180, img: "/icons/RedArrowIcon.png" },
  { id: 6, x: 1520, y: 400, rotation: 180, img: "/icons/RedArrowIcon.png" },
  { id: 7, x: 1520, y: 600, rotation: 180, img: "/icons/RedArrowIcon.png" },
  { id: 8, x: 1520, y: 800, rotation: 180, img: "/icons/RedArrowIcon.png" },
];

export const playersAtSpawnPoints = (spawnPoints, imageWidth, imageHeight) => {
  const players = DEFAULT_PLAYERS.map((player) => ({ ...player }));
  if (!Array.isArray(spawnPoints) || spawnPoints.length === 0) return players;

  if (!(imageWidth > 0) || !(imageHeight > 0)) {
    throw new Error("Cannot apply spawn points without valid map image dimensions.");
  }

  for (const spawn of spawnPoints) {
    if (
      !spawn ||
      !Number.isInteger(spawn.playerId) ||
      !players.some((player) => player.id === spawn.playerId) ||
      !Number.isFinite(spawn.x) ||
      !Number.isFinite(spawn.y) ||
      spawn.x < 0 ||
      spawn.x > 1 ||
      spawn.y < 0 ||
      spawn.y > 1 ||
      (spawn.rotation !== undefined && !Number.isFinite(spawn.rotation))
    ) {
      throw new Error(`Invalid spawn point: ${JSON.stringify(spawn)}`);
    }

    const player = players.find((item) => item.id === spawn.playerId);
    player.x = spawn.x * imageWidth;
    player.y = spawn.y * imageHeight;
    if (spawn.rotation !== undefined) player.rotation = spawn.rotation;
  }

  return players;
};

export const makeNormalizedSpawnPoint = (stagePoint, mapBounds, playerId) => {
  if (!stagePoint) return null;
  const { x, y, width, height } = mapBounds;
  if (
    stagePoint.x < x ||
    stagePoint.x > x + width ||
    stagePoint.y < y ||
    stagePoint.y > y + height
  ) {
    return null;
  }

  return {
    playerId,
    x: Number(((stagePoint.x - x) / width).toFixed(4)),
    y: Number(((stagePoint.y - y) / height).toFixed(4)),
    rotation: 0,
  };
};
